quick radio

<script>
import * as _ from 'lodash'
export default {
  model: {
    event: 'update',
  },
  props: {
    questionId: { type: Number, required: true },
    questionTitle: { type: String, required: true },
    questionOptions: { type: Array, required: true },
    questionType: { type: String, required: true },
    selected: { type: null, required: true },
  },
  data() {
    return {
      radioGroup: 1,
      radioAns: _.cloneDeep(this.selected ? this.selected.value : null),
      row: null,
    }
  },
  watch: {
    selected(newValue) {
      if (_.isEmpty(newValue)) {
        this.radioAns = []
      }
    },

    radioAns(newValue) {
      if (newValue) {
        this.$emit(
          'update',
          this.questionOptions.find((x) => x.value === newValue)
        )
      }
    },
  },

  created() {},
  methods: {
    changeData() {
      this.$emit('updateData')
    },
  },
}
</script>

<template>
  <div :class="$style.radioWrapp">
    <h3 :class="$style.question">{{ questionTitle }}</h3>
    <ul :class="[$style.questionOptionList]">
      <li
        v-for="(options, key) in questionOptions"
        :key="key"
        :class="$style.widthClss"
      >
        <v-radio-group v-model="radioAns" row hide-details="auto">
          <v-radio
            :label="options.value"
            :value="options.value"
            color="#0476D9"
          ></v-radio>
        </v-radio-group>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.question {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: #454648;
}

.questionOptionList {
  display: flex;
  flex-wrap: wrap;
  padding: 0 !important;
  margin: 0;
  list-style: none;
}
.questionOptionList li {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}
.widthClss {
  width: 100%;
}
</style>

<style scoped>
/deep/ .v-input--selection-controls .v-radio > .v-label {
  font-size: 14px;
  color: #454648 !important;
}
.v-radio .v-input--selection-controls__input .v-icon.mdi-radiobox-blank {
  color: #0476d9 !important;
}
</style>
